import BaseStudentModel from "~/models/eschoolplus/registration/Student";
import Statistic from "./Statistic";
import StudentContacts from "./StudentContacts";

export default class Student extends BaseStudentModel {
  // Define a base url for a REST API
  baseURL() {
    return useRuntimeConfig().public.apiBase + "/api/v2/mtss";
  }

  // Set the resource route of the model
  resource() {
    return "students";
  }

  relations() {
    return {
      mtss_statistics: Statistic,
      student_contacts: StudentContacts,
    };
  }

  // Lazy "Relationships"

  // Computed Attributes
  get display_student_grade() {
    if (!this.academic) {
      return this.GRADE;
    }

    return `${this.GRADE} (${this.academic.GRADUATION_YEAR})`;
  }

  get display_dean_name() {
    if (!this.academic || !this.academic.dean) {
      return "None";
    }
    return this.academic.dean.display_name || "None";
  }

  get display_counselor_name() {
    if (!this.counselor_info) {
      return "None";
    }
    return this.counselor_info.display_name || "None";
  }

  // Helper Functions

  /**
   *  Handle Changes to Related Data
   **/
  updateRelatedData(model, myKey, matchFn) {
    //console.log("updateRelatedData", model, myKey, matchFn);
    if (typeof this[myKey] != "object" || !Array.isArray(this[myKey])) {
      // Don't care about save.
      return;
    }

    const dataIndex = this[myKey].findIndex(matchFn);
    if (dataIndex == -1) {
      this[myKey].push(model);
    } else {
      this[myKey].splice(dataIndex, 1, model);
    }
  }

  removeRelatedData(model, myKey, matchFn) {
    //console.log("removeRelatedData", model, myKey, matchFn);
    if (typeof this[myKey] != "object" || !Array.isArray(this[myKey])) {
      // Don't care about save.
      return;
    }

    const dataIndex = this[myKey].findIndex(matchFn);
    if (dataIndex != -1) {
      this[myKey].splice(dataIndex, 1);
    }
  }

  // Updated Data
  savedMessage(message) {
    const model = new Message(message).for(this);

    this.updateRelatedData(model, "messages", (i) => i.id == model.id);
  }

  deletedMessage(message) {
    this.removeRelatedData(message, "messages", (i) => i.id == message.id);
  }
}
